import script from "./TradingViewTicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingViewTicker.vue?vue&type=script&setup=true&lang=js"

import "./TradingViewTicker.vue?vue&type=style&index=0&id=c7ce3bdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7ce3bdc"]])

export default __exports__